import React, { useCallback } from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createAreaChartOption, type ChartViewport } from '../lib/chart-options';
import type { ChartData } from '@/entities/dashboard';
import type { ExportOptions, ChartExportOptions } from '@/shared/lib/export';

interface AreaChartProps {
  data?: ChartData;
  height?: number | string;
  className?: string;
  loading?: boolean;
  showExport?: boolean;
  exportOptions?: {
    png?: ChartExportOptions;
    csv?: ExportOptions;
    xlsx?: ExportOptions;
  };
  exportPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const EMPTY_DATA: ChartData = {
  title: '',
  categories: [],
  series: [],
  unitLabel: '',
  metricLabel: ''
};

export const AreaChart: React.FC<AreaChartProps> = ({
  data,
  height,
  className,
  loading,
  showExport,
  exportOptions,
  exportPosition
}) => {
  const buildOption = useCallback(
    (viewport: ChartViewport) => createAreaChartOption(data || EMPTY_DATA, viewport),
    [data]
  );

  return (
    <EChartsWrapper
      option={buildOption}
      height={height}
      className={className}
      loading={loading}
      showExport={showExport}
      exportOptions={exportOptions}
      exportPosition={exportPosition}
    />
  );
};
